import { OrdemUtils } from './../../../shared/util/ordem-utils';
import { SolicitacaoService } from '../../../core/apis/solicitacao/solicitacao.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ActivatedRoute, Navigation, Router } from '@angular/router';
import { Globals } from 'src/app/shared/helpers/globals';
import { MatDividerModule } from '@angular/material/divider';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { HttpResponse } from '@angular/common/http';
import { GenerateUrlCartaResponse } from 'src/app/core/model/generateUrlCartaResponse';
import { OrdemHistorico, OrdemOutros, Ordem } from 'src/app/core/model/ordem';
import { TipoOrdemPipe } from 'src/app/shared/pipe/tipo-ordem.pipe';
import { StatusOrdemPipe } from 'src/app/shared/pipe/status-ordem.pipe';
import { DateUtils } from 'src/app/shared/util/date-utils';
import { TipoOrdem } from 'src/app/core/model/enum/tipo-ordem.enum';
import { OrdemTextUtil } from 'src/app/shared/util/ordem-text-util';
import { StringUtil } from 'src/app/shared/util/string-util';

@Component({
    selector: 'app-dados-ordem',
    templateUrl: './dados-ordem.component.html',
    styleUrls: ['./dados-ordem.component.css'],
    providers: [provideNgxMask()],
    imports: [
        CommonModule,
        MatToolbarModule,
        MatCardModule,
        MatButtonModule,
        MatDividerModule,
        NgxMaskPipe,
        TipoOrdemPipe,
        StatusOrdemPipe
    ]
})
export class DadosOrdemComponent implements OnInit {

  manterBusca: boolean = false;

  ordem!: Ordem;

  tokenIam!: string;

  constructor(
    private solicitacaoService: SolicitacaoService,
    private activatedRoute: ActivatedRoute,
    private globals: Globals,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const navigation = this.router.lastSuccessfulNavigation;
    if (navigation) {
      this.getDataFromNavigation(navigation);
    }
  }

  private getDataFromNavigation(navigation: Navigation) {
    const state = navigation.extras.state;

    if (state) {
      this.ordem = state['data'];
      this.tokenIam = state['token'];
      this.manterBusca = state['manterBusca'];
    } else {
      this.globals.showSnackBar("Desculpe! Algo de errado aconteceu.");
      this.router.navigate(["listar-ordem"]);
    }
  }

  public getNroSolicitacao(): string {
    return `${this.ordem.numeroOrdem}/${this.ordem.anoOrdem}`;
  }

  public getDiasSla(): string {
    const diasSla = this.ordem.horasSla / 24
    return `${diasSla} ${diasSla === 1 ? "dia": "dias"}`;
  }

  public hasDescricao(): boolean {
    return this.isTipoOrdem(TipoOrdem.OUTROS) || this.isTipoOrdem(TipoOrdem.REVOGACAO);
  }

  public hasAnexo(): boolean {
    const ordemOutros = OrdemUtils.getAsTipo<OrdemOutros>(this.ordem);
    return this.isTipoOrdem(TipoOrdem.OUTROS) && ordemOutros.dadosOrdem.arquivo != null;
  }

  public isTipoOrdem(tipoOrdem: TipoOrdem): boolean {
    return OrdemUtils.isTipoOrdem(this.ordem, tipoOrdem);
  }

  public hasMotivoCancelamento(): boolean {
    return this.ordem.status == "CANCELADO" && this.ordem.motivoCancelamento != null;
  }

  public formatValor(valor: number): string {
    return StringUtil.formatValor(valor);
  }


  public getPeriodoHistorico(ordem: OrdemHistorico): number {
    const inicio = new Date(ordem.dadosOrdem.periodoInicial);
    const fim = new Date(ordem.dadosOrdem.periodoFinal);
    return DateUtils.diffInYears(inicio, fim);
  }

  public getTituloByTipoOrdem(): string{
    return OrdemTextUtil.getTituloByTipoOrdem(this.ordem.tipoOrdem , true);
  }

  public isPessoaFisica(nroDocumento: string) {
    return nroDocumento.length == 11;
  }

  public downloadArquivo() {
    this.globals.addToLoading('detalhar-ordem');
    const arquivoId = OrdemUtils.getAsTipo<OrdemOutros>(this.ordem).dadosOrdem.arquivo.idDtDrive;
    this.solicitacaoService.getArquivoUrl(arquivoId, this.tokenIam).subscribe({
      next: (result: HttpResponse<GenerateUrlCartaResponse>) => {
        this.globals.subtractFromLoading();
        window.open(result.body.fileUrl,"_blank");
      },
      error: error => {
        console.error(error);
        this.globals.subtractFromLoading();
      }
    });
  }

  public voltar () {
    if (this.manterBusca) {
      const nroProcessoParam = this.activatedRoute.snapshot.params['nroProcesso'];
      this.router.navigate(["listar-ordem", nroProcessoParam]);
    } else {
      this.router.navigate(["listar-ordem"]);
    }
  }
}
